
var Model = require("../types/Model.js");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;
var Promise = require("promise");

/**
 * Keeps track of options for input preferences, availability.
 * Also tracks the state of the trunk.
 */
module.exports = Model({
	name: "options",
	init: init,
	triggers: triggers,
	listeners: listeners,
	_isInCall: false,
});

function init() {
	return Promise.all([
		AsyncStorage.getItem("layout"),
		AsyncStorage.getItem("complex"),
	]).then(function (results) {
		var layout = results[0] || "list";
		var complex = results[1] || "false";

		this.push({
			available: true,
			input: {},
			trunk: false,
			settings: false,
			layout: layout,
			complex: complex,
			bannernotice: true
		});
	}.bind(this));
}

function triggers() {
	return {
		"available": handle_trigger_toggle_available,
		"trunk": handle_trigger_toggle_trunk,
		"trunk:hide": handle_trigger_hide_trunk,
		"layout": handle_trigger_toggle_layout,
		"complex": handle_trigger_toggle_complex,
		"settings": handle_trigger_toggle_settings,
		"bannernotice": handle_trigger_banner_notice
	};
}

function listeners() {
	return {
		"personal:updated": handle_preferences_update,
		"inputoptions:updated": Model.makeExtender("input"),
		"bannernotice:updated": Model.makeExtender("bannernotice"),
		"calling:updated": track_if_calling,
	};
}

/**
 * Triggered by PersonalData updating. Fetches out the latest availability preference.
 * @param  {Object} preferences The state of PersonalData. Contains `available`
 */
function handle_preferences_update(preferences) {
	this.extend({
		available: preferences.available,
	});
}

/**
 * Handles triggers for toggling availability.
 * Updates availability on server and updates the state
 */
function handle_trigger_toggle_available(data) {
	var available = data.available;
	this.api.people.available(available)
		.then(function () {
			this.extend({
				available: available
			});
		}.bind(this));
	this.emit("usermetrics:trigger:track", `toggle availability to ${available ? "online" : "offline"} in own account menu`);
}

/**
 * Handles triggers for toggling layout to list
 */
function handle_trigger_toggle_layout(data) {
	var layout = data.layout;
	AsyncStorage.setItem("layout", layout);
	this.extend({
		layout: layout
	});

	this.emit("usermetrics:trigger:track", `toggle layout to ${layout} in own account menu`);
}

function handle_trigger_toggle_complex(data) {
	var complex = data.complex;
	AsyncStorage.setItem("complex", complex);
	this.extend({
		complex: JSON.parse(complex)
	});

	this.emit("usermetrics:trigger:track", `toggle complex to ${complex} in own account menu`);
}

function handle_trigger_toggle_settings() {
	this.extend({
		settings: !this.data.settings
	});

	this.emit("usermetrics:trigger:track", this.data.settings ? "view media settings in atouchaway admin settings" : "close media settings in atouchaway admin settings");
}

/**
 * Handles triggers for toggling the trunk visibility.
 */
function handle_trigger_toggle_trunk() {
	this.extend({
		trunk: !this.data.trunk,
		settings: false
	});

	if (this.data.trunk) {
		if (this._isInCall) {
			this.emit("buzz:trigger:video:hide");
		}
		this.dispatch("trunkopened");
		this.emit("usermetrics:trigger:track", "unfold main section in own account menu");
	} else {
		if (this._isInCall) {
			this.emit("buzz:trigger:video:show");
		}
		this.emit("usermetrics:trigger:track", "fold main section in own account menu");
	}
}

/**
 * Handles triggers for hiding the trunk
 */
function handle_trigger_hide_trunk() {
	this.extend({
		trunk: false,
		settings: false
	});

	this.emit("usermetrics:trigger:track", "fold main section in own account menu");
}

/**
 * Handles triggers for toggling banners to
 * be audible or not.  Default is 'true'.
 */
function handle_trigger_banner_notice(data) {
	var enabled = data.enabled === "false";
	this.emit("bannernotice:trigger:set", {
		enabled: enabled
	});
	this.emit("usermetrics:trigger:track", `toggle banner notice to ${enabled} in own account menu`);
}

function track_if_calling(calling) {
	var state = calling.state;
	this._isInCall = (state === "connected");
}
